export const tourEntrySelectedOffer = (tourEntry, isReturnFirst) => {
    const {selectedOfferKey, type, offers} = tourEntry
    const findSelectedOffer = ({offerKey}) => offerKey === selectedOfferKey || (!selectedOfferKey && isReturnFirst)
    switch (type) {
        case 'FLIGHT':
        case 'TRANSFER':
        case 'EXTRA_SERVICE':
        case 'INSURANCE':
            return offers?.find(findSelectedOffer)
        case 'EXCURSION':
        case 'EVENT':
        case 'CRUISE':
            return offers
                ?.map(({offers}) => offers)
                .flat()
                .find(findSelectedOffer)
        case 'ACCOMMODATION':
            return offers
                ?.map(({rooms}) => rooms)
                .flat()
                .find(
                    ({groupedOffers: [{offerKey}]}) =>
                        offerKey === selectedOfferKey || (!selectedOfferKey && isReturnFirst)
                )
        case 'CAR':
            return tourEntry.offer
    }
}
